const Stats = ({ items }) => {
  return (
    <div className="phishbox__stats">
      <div className="phishbox__stats__item-container">
        {items.length >= 1 ? (
          <>
            <div className="phishbox__stats__numbers-container">
              <span className="phishbox__stats__item-percent">%{items[0].percentage}</span>
              <span className="phishbox__stats__item-count">{items[0].count}</span>
            </div>
            <span className="phishbox__stats__item-name">{items[0].displayName}</span>
          </>
        ) : (
          <span className="phishbox__stats__no-data">-</span>
        )}
      </div>
      <div className="phishbox__stats__item-container">
        {items.length >= 2 ? (
          <>
            <div className="phishbox__stats__numbers-container">
              <span className="phishbox__stats__item-percent">%{items[1].percentage}</span>
              <span className="phishbox__stats__item-count">{items[1].count}</span>
            </div>
            <span className="phishbox__stats__item-name">{items[1].displayName}</span>
          </>
        ) : (
          <span className="phishbox__stats__no-data">-</span>
        )}
      </div>
    </div>
  );
};

export default Stats;
